import { makeStyles, createStyles } from '@material-ui/core/styles'

export const useMasonryStyles = makeStyles(() =>
  createStyles({
    root: {
      display: 'flex',
      width: 'auto'
    },

    column: {
      paddingLeft: 11,
      backgroundClip: 'padding-box',

      '&:first-child': {
        paddingLeft: 0
      }
    }
  })
)
